import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('nin-strikethrough-resolution-update');
	},
};
